import React, {useEffect} from 'react';
import InputMap1  from './partials/input-map1';
import drawState  from './enums/drawState';
import { fieldAdded, fieldMapReseted } from './action';
import { Redirect } from "react-router-dom";
import Pages from './enums/pages';
import ValidationType from './enums/validationType';
import { PrevSettings, PrevSettingsContent, PrevSettingsItem } from './components/prevSettings';
import { AsideLayout } from './components/asideLayout';
import { Input } from './components/input';
import { Checkbox } from './components/checkbox';
import { MapButton } from './components/mapButton';
import DefineFieldGeometryModal from './modals/defineFieldGeometryInfo';
import DefineFieldRowsModal from './modals/defineFieldRowsInfo';
import Alert from './components/alert';
import ReactGA from "react-ga4";

const initRowsDistance = 10;
const initRowsAngle = 0;
const initAroundPerimeter = false;

export function Field(props) {
  const [fields, setFields] = 
    React.useState(
      {
        "rowsAngle": props.store.getState()?.field?.rowsAngle ?? initRowsAngle,
        "rowsDistance": props.store.getState()?.field?.rowsDistance ?? initRowsDistance,
        "aroundPerimeter": props.store.getState()?.field?.aroundPerimeter ?? initAroundPerimeter,
        "captcha": '',
        "areFieldDataCompleted": getAreFieldDataCompleted()
      });

  const [errors, setErrors] = React.useState({rowsAngle: '', rowsDistance: '', rowsLinesOnly: '', aroundPerimeter: ''});  
  const [actualDrawState, setactualDrawState] =  React.useState(drawState.MOVEMAP); 
  const [redirect, setRedirect] = React.useState(areRoverDataComplete()? Pages.Field: Pages.Rover);  
  const [showModalDefineFieldGeometry, setShowModalDefineFieldGeometry] = React.useState(false);  
  const [showModalDefineFieldRows, setShowModalDefineFieldRows] = React.useState(false);   
  const [isZoomedToDraw, setIsZoomedToDraw] = React.useState(false);   
  const [hideZoomedToDrawWarning, setHideZoomedToDrawWarning] = React.useState(false);   
  const [captchaImg, setCaptchaImg] = React.useState(null);
  const [drawScenario] = React.useState(createDrawScenarioWithReduxAction);   
  const [removeScenario] = React.useState(createRemoveScenarioWithReduxAction); 

  useEffect(()=>{
    loadImage();
    setactualDrawState(getInitialDrawState());
    const unsubscribe = subscribeStateToReduxStore();
    if (!areFieldDataAlreadySet())
      initReduxStore(props.store);

    document.title = "Field | Route Planning";
    return () => {
      unsubscribe();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

  function getAreFieldDataCompleted() {
    let field = props.store.getState().field;
    return field.start && field.end && field.areaPolygon && field.rowsDistance
  }

  function areRoverDataComplete() {
    let rover = props.store.getState().rover;
    return rover.length && rover.turningRadius && rover.wheelDistance;
  }

  function initReduxStore(store) {
    store.dispatch(fieldAdded({rowsDistance:initRowsDistance}));
    store.dispatch(fieldAdded({rowsAngle:initRowsAngle}));
    store.dispatch(fieldAdded({aroundPerimeter:initAroundPerimeter}));
    store.dispatch(fieldAdded({captcha:''}));
  }

  function areFieldDataAlreadySet() {
    return props.store.getState()?.field && !isObjectEmpty(props.store.getState()?.field);
  }

  if (redirect === Pages.Field)
  {
    let positionOfRotationAxis = props.store.getState().rover.positionOfRotationAxis;
    let positionOfGnsReceiver = props.store.getState().rover.positionOfGnsReceiver;
    return <>
      <div className="interactive-block">
        <div className = "map-toolbar">
          <MapButton isActive={actualDrawState === drawState.MOVEMAP} onClick={() => setactualDrawState(drawState.MOVEMAP)}>
            <i className='icon icon-hand-paper'></i>  
          </MapButton>
          <div className="btn-group">
            <MapButton isActive={actualDrawState === drawState.START} onClick={() => setactualDrawState(drawState.START)} disabled={!isZoomedToDraw}>
              <img className='img-icon mr-2' src='./icon-start.png' alt='Start'/> Start
            </MapButton>
            <MapButton isActive={actualDrawState === drawState.END} onClick={() => setactualDrawState(drawState.END )} disabled={!isZoomedToDraw}>
              <img className='img-icon mr-2' src='./icon-end.png' alt='End'/> End
            </MapButton>
          </div>
          <MapButton isActive={actualDrawState === drawState.AREAPOLYGON} onClick={() => setactualDrawState(drawState.AREAPOLYGON)} disabled={!isZoomedToDraw}>
            <i className='icon icon-vector-square mr-2'></i> Field
          </MapButton>
          <MapButton isActive={false} onClick={ (e) => { props.store.dispatch(fieldMapReseted()); }} className='btn-danger'>
            <i className='icon icon-trash-alt mr-2'></i> Clear map
          </MapButton>
        </div>
        <InputMap1 key = "InputMap1" drawScenario = {drawScenario} removeScenario = {removeScenario} store = {props.store} drawState = {actualDrawState}
          areaPolygon = {props.store.getState().field.areaPolygon} start = {props.store.getState().field.start} end = {props.store.getState().field.end}
          getFeatureIdBystate = {getFeatureIdBystate} getPreventUnorientedPoint = {getPreventUnorientedPoint}
          onZoomChanged = {onZoomChanged} afterFeatureAdded = {afterFeatureAdded}
        />
        <PrevSettings>
          <PrevSettingsContent header ={"Rover"} link = {Pages.Rover}>
            <PrevSettingsItem name={"Wheel Distance"} value={props.store.getState().rover.wheelDistance} unit={"m"}/>
            <PrevSettingsItem name={"Length"} value={props.store.getState().rover.length} unit={"m"}/>
            <PrevSettingsItem name={"Turning radius"} value={props.store.getState().rover.turningRadius} unit={"m"}/>
            {positionOfRotationAxis && <PrevSettingsItem name={"Position of axis of rotation"} value={positionOfRotationAxis} unit={"m"}/>}
            {positionOfGnsReceiver && <PrevSettingsItem name={"Position of GNSS receiver"} value={positionOfGnsReceiver} unit={"m"}/>}
          </PrevSettingsContent>
        </PrevSettings>
      </div>
      <AsideLayout header = {"Define field"} >
        <div className="mb-6" key={"field-aside"}>
          <h2 className="h4-font-size subtitle">1) Define start and end point</h2>
          <div id="startPointMarker" className={`map-step ${isFeatureDone(drawState.START)}`}>
            <i className="icon icon-check pr-2 mb-2" />
            <span>Start point</span>
          </div>
          <div id="endPointMarker" className={`map-step mb-2 ${isFeatureDone(drawState.END)}`}>
            <i className="icon icon-check pr-2" />
            <span>End point</span>
          </div>
        </div>
        <div className="mb-6">
          <div className="d-flex justify-content-between align-items-baseline">
            <h2 className="h4-font-size subtitle">2) Define field geometry</h2>
            <button type="button" className="btn btn-blank h4-font-size text-fade-color" data-toggle="modal"
              onClick = {(e) => { setShowModalDefineFieldGeometry(true); setShowModalDefineFieldRows(false);}}>
              <i className="icon icon-info-circle" />
            </button>
          </div>
          <div id="fieldGeometryMarker" className={`map-step ${isFeatureDone(drawState.AREAPOLYGON)}`}>
            <i className="icon icon-check pr-2" />
            <span>Field geometry</span>
          </div>
        </div>
        <div className="mb-7">
          <div className="d-flex justify-content-between align-items-baseline">
            <h2 className="h4-font-size subtitle">3) Define field rows</h2>
            <button type="button" className="btn btn-blank h4-font-size text-fade-color" data-toggle="modal"
              onClick = {(e) => { setShowModalDefineFieldRows(true);  setShowModalDefineFieldGeometry(false)}}>
              <i className="icon icon-info-circle" />
            </button>
          </div>
          <Input key ="rowsDistance" label = {"Rows distance"} htmlFor = {"rowsDistance"} type="number"  placeholder = {"Meters"} value = {fields["rowsDistance"]}
              error = {errors["rowsDistance"]} unit = {"m"} store = {props.store} min = {0}
              onChange ={(e) => { props.store.dispatch(fieldAdded({rowsDistance:processNumber(e.target.value, 0, 100)}))} }              
          />
          <Input key ="rowsAngle" label = {"Rows angle"} htmlFor = {"rowsAngle"} type="number"  placeholder = {"Degrees"} value = {fields["rowsAngle"]}
            error = {errors["rowsAngle"]} unit = {"°"} min = {-360} max = {360} store = {props.store}
            onChange ={(e) => props.store.dispatch(fieldAdded({rowsAngle:processNumber(e.target.value, 0, 360)}))}
          />
          <Checkbox key ="aroundPerimeter" label = {"Add around the perimeter"} className={"mt-2"} htmlFor = {"aroundPerimeter"} value = {fields["aroundPerimeter"]}
              onChange ={ (e) => props.store.dispatch(fieldAdded({aroundPerimeter:e.target.checked})) }
            />
        </div>
        {captchaImg &&
          <div className="captcha-container">
            <div className="captcha-image">
              <img id="img-captcha" title = "Can't read? Click to change another image." aria-label = "Can't read? Click to change another image."  src = {captchaImg} onClick={() =>loadImage()}/>
            </div>
            <div className="captcha-input">
              <label htmlFor="captcha-input" className='required'>Captcha</label>
              <div className="form-group font-size-lg">
                <input type="text" id='captcha-input' className="form-control mb-1" placeholder="Enter captcha code" maxLength={4} 
                  value = {fields["captcha"]} error = {errors["captcha"]}
                  onChange ={(e) => props.store.dispatch(fieldAdded({captcha:e.target.value}))}
                  onKeyPress={handleCaptchaKeypress}
                />
              </div>
              {errors["captcha"] && <span class="invalid-feedback  input-validation-error">{errors["captcha"]}</span>}             
            </div>
          </div>
        }
        <button type="button" className= {`btn w-100 mx-0 ${!fields["areFieldDataCompleted"] || objectPropsHasValues(errors)? "disabled" : ""}`} 
          onClick={async () => {await generateRoute();} }            
          >Generate route
        </button>                    
      </AsideLayout>
      <div className='alerts-container'>
        {/*this.state.error && <Alert onClick = {(e) => { this.setState({error: null});}} variant='danger'>{this.state.error}</Alert>*/}
        {!isZoomedToDraw 
          && !hideZoomedToDrawWarning 
          && <Alert onClick = {(e) => { setHideZoomedToDrawWarning(true)}} variant='info'>"Your map view is too large. Please zoom in to draw your field. (Field size can be up to 8 km2)"</Alert>}
      </div>
      {showModalDefineFieldGeometry && <DefineFieldGeometryModal show = { showModalDefineFieldGeometry } hideAction = { () => { setShowModalDefineFieldGeometry(false) }} header = { "Define field geometry" }/> }  
      {showModalDefineFieldRows && <DefineFieldRowsModal show = { showModalDefineFieldRows } hideAction = { () => { setShowModalDefineFieldRows(false) }} header = { "Define field rows" }/>}
    </>
  }
  else
    return <Redirect to={redirect} />

  function handleCaptchaKeypress(e) {
    if (e.charCode === 13) {
      generateRoute();
    }
  };

  async function generateRoute() {
    let captchaOk = await processCaptcha();
    if (captchaOk && handleValidation() && fields["areFieldDataCompleted"] && handleValidation()) {
      setRedirect(Pages.FieldResult);
    }
  }

  function afterFeatureAdded() {
    setactualDrawState(drawState.MOVEMAP)
  }

  function onZoomChanged(val) {
    let isZoomedToDraw = val >= 15;
    setIsZoomedToDraw(isZoomedToDraw);
  }

  function createDrawScenarioWithReduxAction() {
    let drawScenario = new Map();
    drawScenario.set(drawState.START, (point) => 
    { 
      return fieldAdded({start: point})
    });
    drawScenario.set(drawState.END, (point) => { 
      return fieldAdded({end: point})}
      );
    drawScenario.set(drawState.AREAPOLYGON, (coordinates) => { 
      return fieldAdded({areaPolygon: coordinates})}
      );

    drawScenario.set(drawState.MOVEMAP, null); 
    return drawScenario;
  }

  function createRemoveScenarioWithReduxAction() {
    let removeScenario = new Map();
    removeScenario.set(drawState.START, () => 
    { 
      return fieldAdded({start: null})
    });
    removeScenario.set(drawState.END, () => { 
      return fieldAdded({end: null})}
      );
    removeScenario.set(drawState.AREAPOLYGON, () => { 
      return fieldAdded({areaPolygon: null})}
      );

    removeScenario.set(drawState.MOVEMAP, null); 
    return removeScenario;
  }

  function subscribeStateToReduxStore() {
    return props.store.subscribe(() => {
      let formFields = {};
      let field = props.store.getState().field;

      formFields["rowsDistance"] = field.rowsDistance;
      formFields["rowsAngle"] = field.rowsAngle;  
      formFields["aroundPerimeter"] = field.aroundPerimeter; 
      formFields["start"] = field.start;
      formFields["end"] = field.end;
      formFields["areaPolygon"] = field.areaPolygon;
      formFields["captcha"] = field.captcha;
      formFields["areFieldDataCompleted"] = (field.start && field.end && field.areaPolygon && field.rowsDistance);
      setFields(formFields);
    });
  }

  function getFeatureIdBystate(myactualDrawState) {
    let field = props.store.getState().field;
    switch(myactualDrawState) {
      case drawState.START:
        return field?.start?.Id;
      case drawState.END:
        return field?.end?.Id;
      case drawState.AREAPOLYGON:
        return Array.isArray(field?.areaPolygon) && field?.areaPolygon?.length > 0? field?.areaPolygon[0]?.Id: null;
      default:
        return null;  
    }
  }

  function getPreventUnorientedPoint(myactualDrawState) {
    return myactualDrawState === drawState.START;
  }

  function isFeatureDone(stepState) {
    return props.store.getState().field[stepState]? "done" : null;
  }

  function handleValidation() {
    let error  = {};
    return (checkValueIsSetOrAddError("rowsDistance", ValidationType.NumberGreaterThanZero, error)
      & ((captchaImg === null || captchaImg === undefined) || checkValueIsSetOrAddError("captcha", ValidationType.MandatoryText, error)))
      & checkValueIsSetOrAddError("rowsAngle", ValidationType.NumberGreaterThanZeroOrZero, error, true)
  }

  function checkValueIsSetOrAddError(propertyName, validationType, error, setState = false) {
    let result = true;

    if (validationType === ValidationType.NumberGreaterThanZero) {
      if ((fields[propertyName] === "" || isNaN(fields[propertyName])) || parseFloat(fields[propertyName]) <= 0) {
        error[propertyName] = "Must be a number greater than zero.";
        result = false;
      }
    }
    else if (validationType === ValidationType.NumberGreaterThanZeroOrZero) {
      if ((fields[propertyName] === "" || isNaN(fields[propertyName])) || parseFloat(fields[propertyName]) < 0) {
        error[propertyName] = "Must be a number greater than or equal to 0.";
        result = false;
      }
    }
    else if (validationType === ValidationType.MandatoryText) {
      if(!fields[propertyName]){
        error[propertyName] =  "Value can not be empty.";
        result = false;
      }
    }
    
    if (setState && !isObjectEmpty(error))
      setErrors(error);
    return result;
  }
  
  function getInitialDrawState() {
    let field = props.store.getState().field;
    if (field.areaPolygon) return drawState.MOVEMAP;
    if (field.end) return drawState.AREAPOLYGON;
    if (field.start) return drawState.END;
    
    return drawState.MOVEMAP;
  }

  function processNumber(value, min, max) {
    if (!value || isNaN(parseFloat(value))) 
      return value;
    let number = parseFloat(value);
    if (number < min) return min;
    if (number > max) return max;

    return number;
  }

  async function processCaptcha() {
    if (setCaptchaImg)
      return true;

    return (!await loadImage());
  }

  async function loadImage() {
    let response = null;
    try {
      response = await fetch('/api/Home/GetCaptchaImage',
      {
        mode: 'cors',
        credentials: 'include'
      });
    }
    catch {}

    if (response.status === "204") return false;
    // console.log(response.text);
    let blob = await response.blob();
    setCaptchaImg(URL.createObjectURL(blob));
    return true;
  }
  
  function isObjectEmpty(obj) {
    return obj
    && Object.keys(obj).length === 0
    && Object.getPrototypeOf(obj) === Object.prototype
  }

  function objectPropsHasValues(obj) {
    for (const key in obj) {
      if (obj[key])
      return true;
    }
    return false;
  }
};